import React from "react";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import { Price } from "../common/Price";
import { BsChevronUp } from "react-icons/bs";
import styled from "styled-components";
import { useSelector } from "react-redux";

const MoreInfoMobile = ({
  onClose,
  sku,
  shape,
  pockets,
  hood,
  padding,
  sleeves,
  tag,
  fit,
  madeIn,
  closure,
  matDescription,
  price,
  model,
  material,
  matComposition,
  fixedPrice,
}) => {
  const { hidePrice } = useSelector((state) => state.system);
  const { offsetTop } = useSelector((state) => state.system);
  return (
    <Flex
      style={{ position: "fixed", zIndex: 8, top: offsetTop }}
      width="100vw"
      height="calc(100vh - 50px)"
      bg="#f2f2f2"
      flexDirection="column"
      padding="10px 40px 0 10px"
      overflowY="auto"
    >
      <Flex
        style={{
          transform: "rotate(-90deg)",
          zIndex: 3,
          position: "fixed",
          right: "-35px",
          top: "24vh",
          borderRadius: "5px 5px 0px 0px",
          border: "1px solid #232323",
        }}
        height="30px"
        width="100px"
        px="10px"
        alignItems="center"
        justifyContent="space-between"
        bg="#232323"
        onClick={onClose}
      >
        <span style={{ color: "white", fontSize: "10px" }}>
          {getLocalizedString("CLOSE")}
        </span>
        <BsChevronUp size="10px" color="white" />
      </Flex>
      <Box mb="10px">
        <div>
          <SpanTitle>{getLocalizedString("MATERIALDESCRIPTION")}</SpanTitle>
          <span>{matDescription}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("Composizione materiale")}:</SpanTitle>
          <span>{matComposition}</span>
        </div>
      </Box>
      <Box mb="10px" bg="#f2f2f2" width="100vw">
        <div>
          <SpanTitle>Style</SpanTitle>
          <SpanTitle>
            {model} - {material}
          </SpanTitle>
        </div>
        <div style={{ marginRight: "35px" }}>
          <SpanTitle>{getLocalizedString("SKU_DESCRIPTION")}</SpanTitle>
          <span>{sku}</span>
        </div>
      </Box>
      <Box mb="10px" bg="#f2f2f2" width="100vw">
        <div>
          <SpanTitle>{getLocalizedString("SHAPE")}</SpanTitle>
          <span>{shape}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("HOOD")}</SpanTitle>
          <span>{hood}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("SLEEVES")}</SpanTitle>
          <span>{sleeves}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("FIT")}</SpanTitle>
          <span>{fit}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("CLOSURE")}</SpanTitle>
          <span>{closure}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("POCKETS")}</SpanTitle>
          <span>{pockets}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("PADDING")}</SpanTitle>
          <span>{padding}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("TAG")}</SpanTitle>
          <span>{tag}</span>
        </div>
        <div>
          <SpanTitle>{getLocalizedString("MADEIN")}</SpanTitle>
          <span>{madeIn}</span>
        </div>
      </Box>
      <div>
        <SpanTitle>{getLocalizedString("Prezzo")}:</SpanTitle>
        <SpanTitle>
          <Price price={fixedPrice || price} />
        </SpanTitle>
      </div>
    </Flex>
  );
};

const SpanTitle = styled.span`
  font-weight: bold;
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 5px;
`;

export default MoreInfoMobile;
